import { render, staticRenderFns } from "./_base-page-title.vue?vue&type=template&id=8ccde35c&scoped=true&"
import script from "./_base-page-title.vue?vue&type=script&lang=js&"
export * from "./_base-page-title.vue?vue&type=script&lang=js&"
import style0 from "./_base-page-title.vue?vue&type=style&index=0&id=8ccde35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccde35c",
  null
  
)

export default component.exports